import { DistrictNcesDetail, SchoolData } from "@nimble/candidate-api/types";

export interface DistrictHeaderModel {
  name: string;
  location: string | null;
  totalSchools: number;
  totalStudents: number | null;
}

export interface SchoolGroupModel {
  school: SchoolData;
  jobCount: number;
}

export interface DistrictResultsModel {
  schoolGroups: SchoolGroupModel[];
  totalSchools: number;
}

export function getDistrictLocation(
  district: DistrictNcesDetail,
): string | null {
  if (!district.address.city) {
    return null;
  }

  return `${district.address.city}, ${district.state_abbreviation}`;
}

export function toDistrictHeaderModel(
  district: DistrictNcesDetail,
): DistrictHeaderModel {
  return {
    name: district.name,
    location: getDistrictLocation(district),
    totalSchools: district.school_count,
    totalStudents: district.student_count,
  };
}

export function toSchoolGroups(schools: SchoolData[]): SchoolGroupModel[] {
  return schools.map((school) => ({
    school,
    jobCount: school.jobpostings?.length ?? 0,
  }));
}

export function toDistrictResultsModel(
  schools: SchoolData[],
  totalSchools: number,
): DistrictResultsModel {
  return {
    schoolGroups: toSchoolGroups(schools),
    totalSchools,
  };
}
